import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    label: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button label */
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "SubmitFeedbackMenuItem.label?c=5adg65suwfs8", defaultMessage: "Submit Feedback" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
